import { http } from "@/lib/http";
export function fetchPolls() {
  return http.get("/api/polls/get_all").then((res) => res.data);
}
export function fetchPoll(id) {
  return http.get(`/api/polls/get/${id}`).then((res) => res.data);
}
export function fetchTopics() {
  return http.get("/api/topics/get_all").then((res) => res.data);
}
export function addPoll(poll) {
  return http.post("/api/polls/add", poll).then((res) => res.data);
}
export function updatePoll(id, poll) {
  return http.post("/api/polls/update", { poll, id }).then((res) => res.data);
}
export function deletePoll(id) {
  return http.delete(`/api/polls/delete/${id}`).then((res) => res.data);
}
export const POLLS_EXPORT_URL = `${
  import.meta.env.VITE_API_BASE_URL
}/api/polls/export`;
